const actions = {
  getContratos: async (
    context,
    {
      vendorId,
      providerId,
      contractNumber,
      supplyName,
      status,
      page,
      perPage,
      search,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`gc/contract`, {
      params: {
        vendorId,
        providerId,
        contractNumber,
        supplyName,
        status,
        page,
        perPage,
        search,
      },
    });

    return response;
  },

  excluirContrato: async (context, { contratoId }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.delete(`gc/contract/${contratoId}`);
    return response;
  },

  getFornecedor: async (context, { per_page, page, search }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/providers`, {
      params: {
        per_page,
        page,
        search,
      },
    });

    return response;
  },

  getSupplies: async (context, filtros = {}) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`gc/supply`, {
      params: filtros,
    });
    return response;
  },

  // Criar tipo de fornecimento
  criarSupply: async (context, supplyData) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`gc/supply`, supplyData);
    return response;
  },

  // Atualizar tipo de fornecimento
  atualizarSupply: async (context, { supplyId, supplyData }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`gc/supply/${supplyId}`, supplyData);
    return response;
  },

  // Excluir tipo de fornecimento
  excluirSupply: async (context, { supplyId }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.delete(`gc/supply/${supplyId}`);
    return response;
  },

  criarContrato: async (context, contratoData) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`gc/contract`, contratoData);
    return response;
  },

  vincularVendorContrato: async (context, { contratoId, vendorsIds }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`gc/contract/${contratoId}/link/vendors`, {
      vendorsIds,
    });
    return response;
  },

  // Desvincular unidades do contrato
  desvincularVendorContrato: async (context, { contratoId, vendorsIds }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`gc/contract/${contratoId}/unlink/vendors`, {
      vendorsIds,
    });
    return response;
  },

  // Buscar detalhes do contrato
  getContratoDetalhe: async (context, contratoId) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`gc/contract/${contratoId}`);
    return response;
  },

  // Listar produtos do contrato
  getContratoProdutos: async (context, contratoId) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`gc/contract/${contratoId}/product`);
    return response;
  },

  // Adicionar produto ao contrato
  adicionarProdutoContrato: async (context, { contratoId, produtoData }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(
      `gc/contract/${contratoId}/product`,
      produtoData
    );
    return response;
  },

  // Editar produto do contrato
  editarProdutoContrato: async (
    context,
    { contratoId, produtoId, produtoData }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    // Preparar apenas os campos permitidos pela API
    const payload = {};

    if (produtoData.amount !== undefined) {
      payload.amount = produtoData.amount;
    }

    if (produtoData.unitaryValue !== undefined) {
      payload.unitaryValue = produtoData.unitaryValue;
    }

    if (produtoData.measurementUnit !== undefined) {
      payload.measurementUnit = produtoData.measurementUnit;
    }

    const response = await api.put(
      `gc/contract/${contratoId}/product/${produtoId}`,
      payload
    );
    return response;
  },

  // Remover produto do contrato
  removerProdutoContrato: async (context, { contratoId, produtoId }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.delete(
      `gc/contract/${contratoId}/product/${produtoId}`
    );
    return response;
  },

  // Buscar histórico do contrato
  getContratoHistorico: async (context, contratoId) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`gc/contract/${contratoId}/history`);
    return response;
  },

  // Atualizar contrato
  atualizarContrato: async (context, { contratoId, contratoData }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`gc/contract/${contratoId}`, contratoData);
    return response;
  },

  // Relatório de contratos
  getContractReport: async (context, filtros) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`gc/contract/report/exportable`, {
      params: filtros,
    });
    return response;
  },

  // Relatório de vínculos do contrato a pedidos de compra
  getContractLinkedPurchaseOrders: async (context, filtros) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(
      `gc/contract/report/exportable/linked/purchase-orders`,
      {
        params: filtros,
      }
    );
    return response;
  },

  // Relatório de Vínculos Requisição
  getRelatorioVinculosRequisicao: async (
    context,
    {
      vendors,
      contractNumber,
      startDate,
      endDate,
      costCenterId,
      product,
      productGroups,
      productCategories,
      supplies,
      status,
      voucherId,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(
      `gc/contract/report/exportable/linked/vouchers`,
      {
        params: {
          vendors,
          contractNumber,
          startDate,
          endDate,
          costCenterId,
          product,
          productGroups,
          productCategories,
          supplies,
          status,
          voucherId,
        },
      }
    );

    return response;
  },

  // Relatório de Produtos Vinculados ao Contrato
  getRelatorioProdutosContrato: async (
    context,
    {
      providerSearch,
      product,
      productGroups,
      productCategories,
      contractNumber,
      startDate,
      endDate,
      supplyName,
      status,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(
      `gc/contract/report/exportable/contract-product`,
      {
        params: {
          providerSearch,
          product,
          productGroups,
          productCategories,
          contractNumber,
          startDate,
          endDate,
          supplyName,
          status,
        },
      }
    );

    return response;
  },

  // Vincular contrato ao pedido de compras
  vincularPedidoContrato: async (
    context,
    { contratoId, pedidoId, purchaseOrderProducts }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const data = {};

    // Se purchaseOrderProducts for fornecido, incluir no payload
    if (purchaseOrderProducts) {
      data.purchaseOrderProducts = purchaseOrderProducts;
    }

    const response = await api.put(
      `gc/contract/${contratoId}/link/purchase-order/${pedidoId}`,
      data
    );
    return response;
  },

  getStockReport: async (context, params) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get("vendors/reports/stock", {
      params: params,
    });

    return response;
  },

  getCategory: async (context, params) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get("product-categories", {
      params: params,
    });

    return response;
  },

  desvincularPedidoCompra: async (
    context,
    { contratoId, pedidoId, purchaseOrderProducts }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const data = {};

    // Se purchaseOrderProducts for fornecido, incluir no payload
    if (purchaseOrderProducts) {
      data.purchaseOrderProducts = purchaseOrderProducts;
    }

    const response = await api.put(
      `gc/contract/${contratoId}/unlink/purchase-order/${pedidoId}`,
      data
    );
    return response;
  },

  getContratoAnexos: async (
    context,
    { contratoId, fileName, perPage, page }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`gc/contract/${contratoId}/file`, {
      params: {
        fileName,
        perPage,
        page,
      },
    });
    return response;
  },

  uploadContratoAnexo: async (
    context,
    { contratoId, fileName, fileBase64, description }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`gc/contract/${contratoId}/file`, {
      fileName,
      fileBase64,
      description,
    });
    return response;
  },

  deletarContratoAnexo: async (context, { contratoId, fileId }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.delete(
      `gc/contract/${contratoId}/file/${fileId}`
    );
    return response;
  },
};

export const gdcStore = {
  namespaced: true,
  actions,
};
